export class ProductAnalyticalResult {
    public modelId: number;
    public productId: number;
    public numberOfTriangles: number;
    public size: number;
    public volume: number;
    public density: number;
}